import _ from 'lodash'
import React, {useEffect, useState} from 'react'
import LoadingBlock from "../LoadingBlock";

export const DelayRender = ({
                                active = true,
                                lazy,
                                time = 150,
                                children = null,
                                LoadingComponent = () => <LoadingBlock style={{height: '100vh'}}/>,
                            }) => {
    const [ready, setReady] = useState(
        lazy ? <LoadingComponent/> : children || null
    )
    useEffect(
        () => {
            let timeout
            if (active) {
                timeout = setTimeout(() => {
                    requestAnimationFrame(() => {
                        let ready
                        if (
                            _.isFunction(children)
                        ) {
                            ready = children()
                            if (
                                ready &&
                                ready != null
                            )
                                setReady(ready)
                        } else {
                            if (
                                children &&
                                children !== null
                            )
                                setReady(
                                    children || null
                                )
                        }
                    })
                }, time)
            }

            return () => {
                timeout && clearTimeout(timeout)
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [children, active]
    )
    if (!active)
        return _.isFunction(children)
            ? children()
            : children
    return ready
}
